import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { loadRandomLoadingAnimation } from "./loading-animal-animation";

export default function LoadingAnimalAnimation() {
  const [animation, setAnimation] = useState<Awaited<ReturnType<typeof loadRandomLoadingAnimation>> | null>(null);

  useEffect(() => {
    let active = true;
    // Short auth/route loads should finish without downloading decorative
    // animation code. Longer waits retain the existing random animal animation.
    const timeout = setTimeout(() => {
      void loadRandomLoadingAnimation()
        .then((loaded) => {
          if (active) setAnimation(loaded);
        })
        .catch(() => {
          // Optional decoration must never hide loading text or recovery controls.
        });
    }, 500);
    return () => {
      active = false;
      clearTimeout(timeout);
    };
  }, []);

  return (
    // Some of the animals are drawn in black (the toucan); the dark themes give them a faint light edge
    // so they do not vanish into the page (src/theme/jungleThemeArtwork.css).
    <Box height="140px" aria-hidden="true" className="jungle-rim-lit">
      {animation && (
        <animation.Lottie animationData={animation.animationData} loop={true} autoplay={true} style={{ height: 140 }} />
      )}
    </Box>
  );
}
